import GeckoStore from '../gecko-store';

const GeckoPermissions = {
  memberOf(type) {
    const user = GeckoStore.redux.get('appState.loggedInUser');
    if (!user) {
      return false;
    }
    const groups = GeckoStore.redux.get('groups');
    let group;
    if (groups && groups.length) {
      group = groups.find((g) => g.id === user.group_id);
    }
    if (!group && user.Group) {
      return user.Group.type === type;
    }
    if (!group) {
      return false;
    }
    return group.type === type;
  },
  getUserGroup() {
    const groups = GeckoStore.redux.get('groups');
    const loggedInUser = GeckoStore.redux.get('appState.loggedInUser');
    if (!loggedInUser) {
      return 'User';
    }
    const group = groups.find((group) => group.id === loggedInUser.group_id);
    if (!group) {
      return 'User';
    }
    return group.type;
  },
};

export default GeckoPermissions;
